module.exports = __webpack_public_path__ + "static/media/repair-inactive.0270d672.svg";